import { RouteRecordRaw } from "vue-router";

import usePermissions from "@/hooks/use-permissions";
import ConfigurationSimulatorPage from "@/pages/games/GameDisplay/children/configurations/ConfigurationSimulator/ConfigurationSimulatorPage.vue";

import links from "./links";

const { canReadConfigurations } = usePermissions();

export default <RouteRecordRaw[]>[
  {
    path: "",
    component: ConfigurationSimulatorPage,
    name: links.games.simulator,
    props: (route) => ({
      ...route.params,
      query: {
        platform: route.query.platform || "",
        schedule: route.query.schedule || undefined,
        gameVersion: route.query.gameVersion || "",
        segmentIds: typeof route.query?.segmentIds === "string" ? route.query.segmentIds.split(",") : [],
        abTestIds: typeof route.query?.abTestIds === "string" ? route.query.abTestIds.split(",") : [],
        abTestCohortIds: typeof route.query?.abTestCohortIds === "string" ? route.query.abTestCohortIds.split(",") : [],
        simulationDate: route.query.simulationDate || "",
      },
    }),
    meta: {
      title: "Configuration simulator",
      permission: canReadConfigurations,
    },
  },
];
